import cookies from 'js-cookie';

export default {
  namespaced: true,
  state: () => ({
    user: null,
    loginAlert: false,
  }),
  mutations: {
    setUser(state, user) {
      if (!state.user || !user) {
        state.user = user;
      } else {
        state.user = { ...state.user, ...user };
      }
    },
    setLoginAlert(state, condition) {
      state.loginAlert = condition;
    },
  },
  getters: {
    accessToken: () => (expire) => {
      const exp = cookies.get('accessTokenExpire') || expire;
      if (!exp) {
        return false;
      }

      return new Date(exp - 1 * 60000) > Date.now();
    },
    refreshToken: () => (expire) => {
      const exp = cookies.get('refreshTokenExpire') || expire;
      if (!exp) {
        return false;
      }

      return new Date(exp - 1 * 60000) > Date.now();
    },
    hasAnyAdminLegacyPermissions(state, getters) {
      return getters.user.role === 'admin' || getters.perms.find((v) => v.startsWith('admin-legacy.'));
    },
    hasAnyAdminPermissions(state, getters) {
      return getters.user.role === 'admin' || getters.perms.find((v) => v.startsWith('admin.'));
    },
  },
  actions: {
    async logout({ commit }, { reset = true } = {}) {
      try {
        const res = await this.$axios.post('/auth/logout');
        if (reset) {
          commit('setUser', null);
        }
        return res.headers['set-cookie'] || true;
      } catch {
        if (reset) {
          commit('setUser', null);
        }
      }

      return true;
    },
    async checkAuth({
      getters: { accessToken, refreshToken }, dispatch, commit,
    }, { accessTokenExpire, refreshTokenExpire } = {}) {
      if (!accessToken(accessTokenExpire)) {
        if (refreshToken(refreshTokenExpire)) {
          return dispatch('refreshAccessToken');
        }

        commit('setUser', null);

        return false;
      }

      return true;
    },

    async checkNeedToRefreshAccessToken({ getters }) {
      if (!getters.accessToken()) {
        if (getters.refreshToken()) {
          return true;
        }

        return false;
      }

      return false;
    },

    async refreshAccessToken({ dispatch }) {
      const res = await this.$axios.post('/auth/token/refresh', { }, { progress: false, noError: true }).catch(() => false);

      if (res) {
        if (res.data.user) {
          dispatch('setUserInfo', res.data.user);
        }

        return res.headers['set-cookie'];
      }

      return false;
    },

    async setUserInfo({ commit }, userPayload) {
      if (userPayload.businessAccount) {
        commit('setLoginAlert', true);
      }
      if (userPayload.userId) {
        const {
          userId,
          userType,
          userEmail,
          userName,
        } = userPayload;

        commit('setUser', {
          id: userId,
          type: userType,
          email: userEmail,
          name: userName,
        });
      } else {
        commit('setUser', { ...userPayload, avatarUrl: `${this.$config.imagesUrl}/avatars` });
      }
    },
  },
};
